import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsRouting } from '@modules/home/tabs/news/news.routing';
import { SharedModule } from '@shared/shared.module';
import {DirectivesModule} from '@shared/directives/directives.module';
import {NewsPageComponent} from './pages/news-page/news-page.component';
import {NewsPageWrapperComponent} from './pages/news-page-wrapper/news-page-wrapper.component';
import {NewsPageMyNewsComponent} from './pages/news-page-my-news/news-page-my-news.component';
import {SharedPipesModule} from '@shared/pipes/pipes.module';
import {VotingModule} from '@modules/voting/voting.module';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import {FilterModule} from '@shared/components/filter/filter.module';
import {SharedNewsDetailModule} from '@shared/modules/shared-news-detail/shared-news-detail.module';
import {SharedNewsListModule} from '@shared/modules/shared-news-list/shared-news-list.module';

@NgModule({
  imports: [
    CommonModule,
    NewsRouting,
    SharedModule,
    DirectivesModule,
    SharedPipesModule,
    VotingModule,
    SharedNewsModule,
    SharedNewsDetailModule,
    SharedNewsListModule,
    LibTableModule,
    FilterModule,
  ],
  declarations: [
    NewsPageComponent,
    NewsPageWrapperComponent,
    NewsPageMyNewsComponent,
  ],
})
export class NewsModule { }
